import { useMutation as useTanstackMutation } from '@tanstack/react-query';

interface UseMutationProps {
  mutationKey: string;
  mutationFn: (_?: TypeAny) => void;
  queryData?: unknown;
  onSuccess?: TypeAny;
  onError?: TypeAny;
}

export function useMutation({
  mutationKey,
  mutationFn,
  queryData,
  onSuccess,
  onError
}: UseMutationProps) {
  const { isLoading, mutate, error, data } = useTanstackMutation({
    mutationKey: [mutationKey, queryData],
    mutationFn: async (variables?: TypeAny) => {
      // If variables are passed, use them; otherwise use queryData
      const dataToUse = variables !== undefined ? variables : queryData;
      return mutationFn(dataToUse);
    },
    onSuccess,
    onError,
    retry: 1
  });

  // Create a wrapper that handles both parameterized and non-parameterized calls
  const mutateWrapper = (variables?: TypeAny, options?: TypeAny) => {
    if (variables !== undefined) {
      return mutate(variables, options);
    }
    return mutate(undefined, options);
  };

  return {
    error: error as ResponseObject,
    data: data as TypeAny,
    isLoading,
    mutate: mutateWrapper
  };
}
